export enum CLIENT_CHOICE {
  COUNTRY = 'country',
  SALUTATION = 'salutation_id',
  PERSONAL_STATUS = 'personal_status',
  NATIONALITY = 'nationality',
  PROFESSION = 'berufsgruppe',
  TARIFGRUPPE = 'tarifgruppe',
}

export enum CLIENT_META {
  NATIONALITY_GERMAN = 'hasGermanNationality',

  TARIFGRUPPE_BEAMTER = 'beamter',
}

export const UNKNOWN_PERSONAL_STATUS = '6';
